import {ServiceAppointmentRoutingModule} from './service-appointment-routing.module';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ServiceAppointmentComponent} from './service-appointment.component';
import {SelectServiceComponent} from './select-service/select-service.component';
import {AppointmentTimeComponent} from './appointment-time/appointment-time.component';
import {SharedModule} from '../../shared/shared.module';
import {AppointmentFormService} from './appointment-form.service';
import {ConfirmAppointmentComponent} from './confirm-appointment/confirm-appointment.component';
import {MileageCarouselComponent} from './select-service/mileage-carousel/mileage-carousel.component';
import {CommonModule, CurrencyPipe} from '@angular/common';
import {BdcSharedModule} from '../shared/bdc-shared.module';

import {YourInformationComponent} from './your-information/your-information.component';
import { SummaryComponent } from './summary/summary.component';

@NgModule({
    declarations: [
        ServiceAppointmentComponent,
        SelectServiceComponent,
        AppointmentTimeComponent,
        YourInformationComponent,
        ConfirmAppointmentComponent,
        MileageCarouselComponent,
        SummaryComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BdcSharedModule,
        ServiceAppointmentRoutingModule,
        SharedModule,
    ],
    exports: [],
    providers: [AppointmentFormService, CurrencyPipe]
})
export class ServiceAppointmentModule { }
